'use client'
import React, { ReactElement, ReactNode, useState } from 'react'
import AngleDown from '@/icons/font-awesome/sharp-light/angle-down.svg'
import classNames from 'classnames'

export function HotelDetailClient(props: {
  headline: string
  children: ReactNode
}): ReactElement | null {
  const [isOpened, setIsOpened] = useState(false)

  function toggleIsOpened() {
    setIsOpened(!isOpened)
  }

  return (
    <div className="border-b border-stone-200 first:border-t">
      <div
        onClick={toggleIsOpened}
        className="flex cursor-pointer justify-between py-5 text-stone-800"
      >
        <h2 className="text-xl font-semibold">{props.headline}</h2>
        <AngleDown className={`h-6 w-6 fill-stone-400 ${isOpened ? 'rotate-180' : ''}`} />
      </div>
      <div className={classNames('pb-5', { hidden: !isOpened })}>{props.children}</div>
    </div>
  )
}
